<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row">
      <div class="col-12 col-md-6">
        <el-form-item
          :label="L10n('company-type')"
          prop="companyTypeID"
          :rules="rulesCompanyType"
          class="material-style">
          <select-response
            :model.sync="form.companyTypeID"
            :data="dataSourceCompanyType.records"
            :isLoading="dataSourceCompanyType.loading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-12 col-md-6">
        <el-form-item
          :label="L10n('country')"
          prop="country"
          :rules="getValidationRule('required')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.country"
            @input="form.country = valueTrimLeft($event)"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <el-form-item
          :label="L10n('city')"
          prop="city"
          class="material-style">
          <el-input
            :value="form.city"
            @input="form.city = valueTrimLeft($event)"
          />
        </el-form-item>
      </div>
      <div class="col-12 col-md-6">
        <el-form-item
          :label="L10n('street')"
          prop="street"
          class="material-style">
          <el-input
            :value="form.street"
            @input="form.street = valueTrimLeft($event)"
           />
        </el-form-item>
      </div>
    </div>
    <view-more>
      <div class="row">
        <div class="col-6 col-md-3">
          <el-form-item
            :label="L10n('state')"
            prop="state"
            class="material-style">
            <el-input
              :value="form.state"
              @input="form.state = valueTrimLeft($event)"
            />
          </el-form-item>
        </div>
        <div class="col-6 col-md-3">
          <el-form-item
            :label="L10n('zip-code')"
            prop="zipCode"
            class="material-style">
            <el-input
              :value="form.zipCode"
              @input="form.zipCode = valueTrimLeft($event)"
            />
          </el-form-item>
        </div>
        <div class="col-6 col-md-3">
          <el-form-item
            :label="L10n('address-type-division')"
            prop="addressTypeDivisionID"
            class="material-style">
            <select-response
              :model.sync="form.addressTypeDivisionID"
              :data="dataSourceDivision.records"
              :isLoading="dataSourceDivision.loading"
            ></select-response>
          </el-form-item>
        </div>
        <div class="col-6 col-md-3">
          <el-form-item
            :label="L10n('bax-employee')"
            prop="baxEmployeeID"
            class="material-style">
            <select-response
              :model.sync="form.baxEmployeeID"
              :fields="{id: 'id', title: 'name'}"
              :data="dataSourceEmployee.records"
              :isLoading="dataSourceEmployee.loading"
            ></select-response>
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-6 col-md-3">
          <el-form-item
            :label="L10n('fax')"
            prop="zipCode"
            class="material-style">
            <el-input
              :value="form.fax"
              @input="form.fax = valueTrimLeft($event)"
            />
          </el-form-item>
        </div>
        <div class="col-6 col-md-3">
          <el-form-item
            :label="L10n('phone')"
            prop="state"
            class="material-style">
            <el-input
              :value="form.phone"
              @input="form.phone = valueTrimLeft($event)"
            />
          </el-form-item>
        </div>
        <div class="col-6 col-md-3">
          <el-form-item
            :label="L10n('email')"
            prop="email"
            class="material-style">
            <el-input
              :value="form.email"
              @input="form.email = valueTrimLeft($event)"
            />
          </el-form-item>
        </div>
        <div class="col-6 col-md-3">
          <el-form-item
            :label="L10n('score')"
            prop="scoreID"
            class="material-style">
            <select-response
              :model.sync="form.scoreID"
              :fields="{id: 'id', title: 'scoreText'}"
              :data="dataSourceScore.records"
              :isLoading="dataSourceScore.loading"
            ></select-response>
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4">
          <el-form-item
            :label="L10n('vat-number')"
            prop="vatNumber"
            class="material-style">
            <el-input
              ref="firstField"
              :value="form.vatNumber"
              @input="form.vatNumber = valueTrimLeft($event)"
            />
          </el-form-item>
        </div>
        <div class="col-12 col-md-8">
          <el-form-item
            :label="L10n('remark')"
            prop="remark"
            class="material-style">
            <el-input
              ref="firstField"
              type="textarea"
              :rows="2"
              :value="form.remark"
              @input="form.remark = valueTrimLeft($event)"
            />
          </el-form-item>
        </div>
      </div>
    </view-more>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { api } from '@/services/api'

export default {
  name: 'FormCompanyDetails',
  mixins: [Form],
  components: {
    'view-more': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ViewMore.vue')
  },
  props: {
    companyID: { required: true }
  },
  data () {
    return {
      rulesCompanyType: [
        { validator: this.validatorCompanyType, trigger: 'change' }
      ]
    }
  },
  computed: {
    dataSourceCompanyType () {
      return this.API('CompanyTypes/GetAllDynamic?select=id,title')
    },
    dataSourceDivision () {
      return this.API('Divisions/GetAllDynamic?select=id,title')
    },
    dataSourceScore () {
      return this.API('Scores/GetAllDynamic?select=id,scoreText')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name&filter=isActive==true')
    }
  },
  methods: {
    validatorCompanyType (rule, value, callback) {
      let error = new Error(this.L10n('not-allow-more-then-one-company-type'))
      if (value == null || value === '') {
        callback()
      }
      this.getCountDetailsWithCompanyType()
        .then(data => {
          if (data.count === 0) {
            callback()
          } else if (data.count === 1 && data.value.some(detail => detail.id === this.form.id)) {
            callback()
          } else {
            callback(error)
          }
        })
    },
    getCountDetailsWithCompanyType () {
      return api
        .get(`CompanyDetails/GetAllDynamic`, {
          params: {
            'select': 'id,companyTypeID',
            'filter': `companyID == ${this.companyID} && companyTypeID != null`,
            'count': true
          }
        })
        .then((response) => {
          return response.data
        })
    }
  }
}
</script>
